import qs from 'qs';
import _ from 'lodash';
export function getVar(key, type = 'string') {
    // todo!!!
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (_.has(query, key)) {
        const value = _.get(query, key);
        if (_.isNull(value) || _.isUndefined(value)) {
            return true;
        }
        if (type === 'boolean') {
            if (_.lowerCase(value) === 'false') {
                return false;
            }
            else {
                return true;
            }
        }
        return value;
    }
    return localStorage.getItem(key);
}
export const ENV = getVar('env');
export const IS_QA = (ENV === 'qa') || /qa-/.test(location.host);
export const IS_RELEASE = (ENV === 'release') || /release-/.test(location.host);
export const IS_PROD = !(IS_QA || IS_RELEASE);
export const IS_DEBUG = getVar('fe_debug', 'boolean');
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_VERBOSE = getVar('_verbose', 'boolean');
export const REGION = getVar('region');
export const NO_REDIRECT = getVar('no_redirect', 'boolean');
export const PERMISSION = getVar('permission', 'boolean');
export const IsAdmin = getVar('_ad') === '1';
export const isMockApproval = getVar('mock_approval', 'boolean');
export const Environment = {
    permission: PERMISSION,
    development: IS_DEVELOPMENT,
    debug: IS_DEBUG,
    verbose: IS_VERBOSE,
    region: REGION,
    noRedirect: NO_REDIRECT,
    isMockApproval: isMockApproval,
};
